import React from 'react';
import { useQuery } from 'react-query';
import { fetchFacetItemsNoMeta } from '@sls-react/api/items';
import { RailsBlock } from '@sls-react/typings/services/rails/tile';
import useMobile from '@sls-react/hooks/useMobile';
import ItemThumbnail from '@sls-react/components/ItemThumbnail/ItemThumbnail';
import ItemThumbnailGrid from '@sls-react/components/ItemGrids/ItemThumbnailGrid';
import useItemGridMeta from '@sls-react/hooks/useItemGridMeta';

interface Props {
  block: RailsBlock;
  rows: number;
}

const ItemGridRowBlock: React.FC<Props> = ({ block, rows }) => {
  const mobile = useMobile();
  const { data: items } = useQuery(
    ['item-block', block.query, rows],
    () =>
      fetchFacetItemsNoMeta({
        ...block.query,
        page_size: mobile ? rows * 4 : rows * 6,
      }),
    {
      refetchOnMount: false,
    },
  );
  useItemGridMeta(items);

  return (
    <div
      css={`
        padding-left: 0.5px;
        padding-bottom: 0.5px;
      `}
    >
      <ItemThumbnailGrid>
        {items?.map((item, i) => (
          <ItemThumbnail
            key={item.id}
            item={item}
            // When this block is one of the first few rendered, send position to load the image eagerly
            // to optimize the LCP web-vital
            position={block.id! < 3 ? i : undefined}
          />
        ))}
      </ItemThumbnailGrid>
    </div>
  );
};

export default ItemGridRowBlock;
